// The one place this app reads Django's CSRF cookie.
//
// Two surfaces need it, and both need it for the same reason: their
// credential is a cookie the browser attaches by itself, so a cross-site page
// could otherwise post on the person's behalf. The claim journey's three
// addresses are one; the federated sign-in start is the other, because
// beginning a login is not a read — a page that could trigger one could sign
// somebody into an account of the attacker's choosing.
//
// Everything else the portal calls carries a bearer token in a header, which no
// cross-site page can make the browser attach, and needs none of this.

/**
 * The token Django set as a cookie, for the header or form field it wants it
 * back in.
 *
 * Read from `document.cookie` on every call rather than held in a variable,
 * because the cookie is the authority and a rotation would leave a copy stale.
 * Returns an empty string where there is none, which the server refuses — the
 * right outcome, since a post before the surface's first read is a post from
 * somewhere other than that surface.
 */
export function csrfToken(): string {
  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
}
